export enum AppEvents {
  LoginNovoCadastro = "Login_Novo_Cadastro",
  Login = "Login",
}
